// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3vYma"};